import { StyleSheet, View } from 'react-native';

import { Skeleton } from 'components/ui/skeleton';

import { BadgeBaseCard } from './badge-base-card';

export const BadgesSectionSkeleton = () => {
  return (
    <View style={styles.wrapper}>
      {Array.from({ length: 2 }).map((_, index) => (
        <BadgeBaseCard
          image={<Skeleton shape="rectangle" style={styles.imageSkeleton} />}
          title={<Skeleton shape="rectangle" style={styles.titleSkeleton} />}
          subtitle={<Skeleton shape="rectangle" style={styles.subtitleSkeleton} />}
          key={index}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    paddingHorizontal: 18,
    flexDirection: 'row',
    gap: 8,
  },
  imageSkeleton: {
    width: 104,
    height: 104,
    marginVertical: 0,
  },
  titleSkeleton: {
    height: 20,
    width: '100%',
    marginVertical: 0,
  },
  subtitleSkeleton: {
    height: 15,
    width: '100%',
    marginVertical: 0,
  },
});
